import {dateClear} from "../../fields/date-field/date-field";

const filterItems = document.querySelectorAll<HTMLElement>('.i-filter');

filterItems.forEach(filter => {
  const inputs = filter.querySelectorAll<HTMLInputElement>('input');
  const clear = filter.querySelector<HTMLElement>('.i-filter__clear');

  inputs.forEach(input => {
    input.addEventListener('change', () => filter.dispatchEvent(new Event('filter')))
  })

  clear?.addEventListener('click', (e) => {
    e.preventDefault();
    inputs.forEach(input => {
      if(input.type == "checkbox") input.checked = false;
      else if (input.classList.contains('flatpickr')) dateClear(input);
      else input.value = ""
    })

    filter.dispatchEvent(new Event('filter'))
  })
})
